import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

import Layout from 'Layout/Layout';
import markel from 'assets/images/end_subscription_img.png';
import { withLocale } from '@dietlabs/components';
import { dateTimeToDate } from 'utils/date';

class DietInFuture extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        date: PropTypes.instanceOf(Date).isRequired,
        renderTimeline: PropTypes.func.isRequired,
    };

    render() {
        const { date } = this.props;

        const numberOfDays =
            1 +
            (dateTimeToDate(date) - dateTimeToDate(new Date())) /
                1000 /
                60 /
                60 /
                24;

        return (
            <Layout page="diet">
                {this.props.renderTimeline()}
                <section className="bg-white mt-5 pt-5">
                    <Container>
                        <Row>
                            <Col
                                xs="12"
                                md={{ size: 6, offset: 3 }}
                                className="text-center"
                            >
                                <img
                                    className="mb-4 img-fluid"
                                    src={markel}
                                    alt=""
                                />
                                <h2 className="title-medium semi-bold">
                                    {this.props.t(
                                        'info-pages/diet-available-in-future/title',
                                        { count: numberOfDays }
                                    )}
                                </h2>
                                <p>
                                    {this.props.t(
                                        'info-pages/diet-available-in-future/content'
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        );
    }
}

export { DietInFuture };
export default withLocale(DietInFuture);
